import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';

const Panel = Collapse.Panel;

function RegistroProgram({ registryProgram }) {
  let programma = 'Il programma non è presente in banca dati';
  if (registryProgram.programma) {
    programma = registryProgram.programma;
  } else if (registryProgram.programmaModuli) {
    const programmaArray = registryProgram.programmaModuli
                                          .filter((v) => v.programma)
                                          .map((v) => v.programma);
    // console.log('debug lunghezza programmaArray', programmaArray.length);
    if (programmaArray.length > 0) {
      programma = programmaArray.join('\n');
    } else {
      programma = '';
    }
  }
  if (registryProgram.altreInformazioni) {
    programma = `${programma} ${registryProgram.altreInformazioni}`;
  }

  if (programma.length === 0) {
    programma = 'Il programma non è presente in banca dati';
  }

  return (
    <Collapse
      className="box box-solid box-unimi vmg10"
    >
      <Panel header="Programma Didattico" key="program">
        <p className="withpre">{programma}</p>
      </Panel>
    </Collapse>
  );
}

RegistroProgram.propTypes = {
  registryProgram: PropTypes.object.isRequired,
};

export { RegistroProgram };
